import { render, staticRenderFns } from "./simpleText.vue?vue&type=template&id=936281b0"
import script from "./simpleText.vue?vue&type=script&lang=ts"
export * from "./simpleText.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports